<template>
<div style="height: 100%;">
  <div :class="$style['desc']">
    <span>기존 대시보드를 활용하여 신규 대시보드를 간편하게 추가할 수 있습니다.</span><br/>
    <span>자신이 기존에 만든 대시보드 뿐 아니라, 다른 관리자가 만든 대시보드를 불러올 수 있습니다.</span><br/>
    <span style="font-size: 12px;">(단, 공개여부를 허락한 대시보드에 한함)</span>
  </div>
  <div :class="$style['content']">
    <el-tabs class="tab-button" v-model="type" v-loading="isLoading">
      <!-- 프로세스 -->
      <el-tab-pane label="기존 대시보드" name="MINE" key="MINE">
        <el-table
          v-if="type === 'MINE'"
          highlight-current-row
          :data="loadDataList"
          @current-change="onCurrentChange"
          >
          <el-table-column prop="dashboardName" label="대시보드명"></el-table-column>
          <el-table-column prop="dashboardDesc" label="대시보드설명"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="공유 대시보드" name="SHARE" key="SHARE">
        <el-table
          v-if="type === 'SHARE'"
          highlight-current-row
          :data="loadDataList"
          @current-change="onCurrentChange"
          >
          <el-table-column prop="dashboardName" label="대시보드명"></el-table-column>
          <el-table-column prop="dashboardDesc" label="대시보드설명"></el-table-column>
          <el-table-column prop="label" label="공유자"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="템플릿 대시보드" name="TEMPLATE" key="TEMPLATE" v-if="dashboardType === DashboardConst.DASHBOARD_TYPE.COORD">
        <el-row :gutter="10" v-for="(index1) in (Math.round(loadDataList.length / 2))" :key="index1" style="margin-bottom: 10px;" v-if="type === 'TEMPLATE'">
          <el-col :span="12" v-for="(index2) in 2" :key="index2">
            <el-card v-if="getDashboardTemplate(index1, index2)" shadow="hover" :class="['template-dashboard-card', (isSelected(index1, index2) ? 'selected' : '')]">
              <div style="background: #000;">
                <img :src="`${baseUrl}${getDashboardTemplate(index1, index2).templateImageUrl}`" class="img">
              </div>
              <div class="content">
                <div class="name">{{ getDashboardTemplate(index1, index2).templateName }}</div>
                <div class="desc">{{ getDashboardTemplate(index1, index2).templateDesc }}</div>
              </div>
              <div class="select-button" @click="onCurrentChange(getDashboardTemplate(index1, index2))">선택</div>
              <i class="el-icon-success check-icon" v-if="isSelected(index1, index2)"></i>
              <el-tooltip content="크게보기" placement="top" :hide-after="1000">
                <el-button icon="el-icon-search" class="preview-button" circle @click="preview(index1, index2)"></el-button>
              </el-tooltip>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</div>
</template>

<script>
import { baseUrl } from '@/config';

import DashboardAPI from '@/api/dashboard/common';

import DashboardConst from '@/constants/dashboard';

export default {
  name: 'WDashboardImportForm',
  props: {
    value: {
      type: Object,
      default: null,
    },
    dashboardType: {
      type: String,
      default: DashboardConst.DASHBOARD_TYPE.GRID,
    },
  },
  data() {
    return {
      baseUrl,
      DashboardConst,
      isLoading: false,
      type: 'MINE',
      loadDataList: [],
      importData: null,
    };
  },
  computed: {
    getDashboardTemplate() {
      return (index1, index2) => this.loadDataList[((index1 - 1) * 2) + (index2 - 1)];
    },
    isSelected() {
      return (index1, index2) => this.importData && this.importData.templateFile === this.getDashboardTemplate(index1, index2).templateFile;
    },
  },
  watch: {
    type() {
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    preview(index1, index2) {
      window.open(`${baseUrl}${this.getDashboardTemplate(index1, index2).templateImageUrl}`, '_blank');
    },
    loadData() {
      this.loadDataList = [];
      this.onCurrentChange(null);

      this.isLoading = true;

      if (this.type === 'TEMPLATE') {
        DashboardAPI.getCoordDashboardTemplateList().then((response) => {
          this.isLoading = false;

          const result = response.data;

          this.loadDataList = result.data;
        });
      } else {
        DashboardAPI.getImportDashboardList(this.type, this.dashboardType).then((response) => {
          this.isLoading = false;
          const result = response.data;

          if (result.success) {
            this.loadDataList = result.data;
          }
        });
      }
    },
    onCurrentChange(data) {
      this.importData = data;

      this.$emit('input', data);
      this.$emit('changeImportData', data);
    },
  },
};
</script>

<style lang="scss">
.template-dashboard-card {
  .el-card__body {
    padding: 0px;
    height: 175px;
    position: relative;
    user-select: none;
  }
  .img {
    width: 100%;
    height: auto;
    transition: all .5s cubic-bezier(.165,.84,.44,1);
  }

  .content {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: calc(175px - 140px);
    min-height: calc(175px - 140px);
    transition: all .5s cubic-bezier(.165,.84,.44,1);
    padding: 5px 10px;
    background: #fff;

    .name {
      font-size: 15px;
      font-weight: bold;
      color: #333;
      letter-spacing: -0.03em;
    }

    .desc {
      margin-top: 10px;
      font-size: 12px;
    }
  }

  &:hover,
  &.selected {
    .img {
      transform: scale(1.1);
      opacity: 0.6;
    }
    .content {
      height: 100px;
    }
  }

  &:hover {
    .preview-button,
    .select-button {
      opacity: 1;
    }
  }

  &.selected {
    .el-card__body {
      cursor: default;
    }
    .select-button {
      opacity: 0;
    }
  }

  .check-icon {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 60px;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .preview-button {
    position: absolute;
    top: 5px;
    right: 5px;
    opacity: 0;
    transition: all .5s cubic-bezier(.165,.84,.44,1);
  }

  .select-button {
    position: absolute;
    top: 0;
    left: 50%;
    color: white;
    border: 2px solid #fff;
    padding: 3px 0px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    font-weight: bold;
    font-size: 17px;
    letter-spacing: 5px;
    width: 100px;
    opacity: 0;
    transform: translate(-50%, 20px);
    transition: all .5s cubic-bezier(.165,.84,.44,1);

    &:hover {
      background: #fff;
      color: #333;
    }
  }
}
</style>
<style module>
.desc {
  height: 100px;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 15px;
  color: #666; /* $evilgray */
}
.content {
  height: calc(100% - 115px);
  overflow-y: scroll;
}
.btn {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/form/DashboardImportForm.vue